import { useState, useEffect } from 'react';

export default function Header() {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [tick, setTick] = useState(0);


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
      setTick(t => t + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    return `${year}.${month}.${day}  ${weekdays[date.getDay()]}`;
  };

  const formatTime = (date: Date) => {
    const h = String(date.getHours()).padStart(2, '0');
    const m = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${h}:${m}:${s}`;
  };

  return (
    <header
      className="relative px-4 py-2.5"
      style={{
        background: 'linear-gradient(to bottom, rgba(10,20,40,0.85), rgba(5,12,25,0.75))',
        borderBottom: '1px solid rgba(34,211,238,0.15)',
        backdropFilter: 'blur(12px)',
      }}
    >
      {/* 顶部亮线 */}
      <div className="absolute top-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(to right, transparent 0%, rgba(34,211,238,0.8) 30%, rgba(34,211,238,1) 50%, rgba(34,211,238,0.8) 70%, transparent 100%)' }}></div>

      {/* 左侧角落装饰 */}
      <div className="absolute left-0 top-0 w-16 h-full pointer-events-none">
        <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 rounded-tl-sm" style={{ borderColor: 'rgba(34,211,238,0.5)' }}></div>
        <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 rounded-bl-sm" style={{ borderColor: 'rgba(34,211,238,0.5)' }}></div>
      </div>
      {/* 右侧角落装饰 */}
      <div className="absolute right-0 top-0 w-16 h-full pointer-events-none">
        <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 rounded-tr-sm" style={{ borderColor: 'rgba(34,211,238,0.5)' }}></div>
        <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 rounded-br-sm" style={{ borderColor: 'rgba(34,211,238,0.5)' }}></div>
      </div>

      {/* 三栏布局容器 */}
      <div className="grid grid-cols-3 items-center gap-4 relative z-10">
        {/* 左侧：时间 + 状态 */}
        <div className="flex items-center gap-3 justify-start">
          <div className="flex flex-col">
            <div className="font-mono text-xs tracking-widest whitespace-nowrap" style={{ color: 'rgba(34,211,238,0.7)', letterSpacing: '0.12em' }}>
              {formatDate(currentTime)}
            </div>
            <div className="font-mono font-bold text-base tracking-widest whitespace-nowrap" style={{ color: '#22d3ee', textShadow: '0 0 10px rgba(34,211,238,0.8)', letterSpacing: '0.1em' }}>
              {formatTime(currentTime)}
            </div>
          </div>

          <div className="w-px h-8 flex-shrink-0" style={{ background: 'linear-gradient(to bottom, transparent, rgba(34,211,238,0.4), transparent)' }}></div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <div className="relative w-2 h-2">
              <div className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-60"></div>
              <div className="w-2 h-2 rounded-full bg-emerald-400" style={{ boxShadow: '0 0 8px rgba(52,211,153,0.9)' }}></div>
            </div>
            <span className="text-xs font-medium whitespace-nowrap" style={{ color: '#34d399', letterSpacing: '0.05em' }}>系统运行正常</span>
          </div>

          <div className="flex items-center gap-1.5 px-2.5 py-1 rounded flex-shrink-0"
            style={{ background: 'rgba(34,211,238,0.06)', border: '1px solid rgba(34,211,238,0.15)' }}>
            <i className="ri-cpu-line text-xs" style={{ color: '#22d3ee' }}></i>
            <span className="text-xs font-mono whitespace-nowrap" style={{ color: 'rgba(34,211,238,0.8)' }}>
              AI 评估中 <span className="animate-pulse">{['▌','▐'][tick % 2]}</span>
            </span>
          </div>
        </div>

        {/* 中间：主标题 */}
        <div className="text-center">
          <h1
            className="font-bold tracking-widest whitespace-nowrap"
            style={{
              fontSize: 'clamp(24px, 3.5vw, 36px)',
              color: '#ffffff',
              textShadow: '0 0 20px rgba(34,211,238,0.9), 0 0 40px rgba(34,211,238,0.5), 0 0 60px rgba(34,211,238,0.3)',
              letterSpacing: '0.18em',
            }}
          >
            天津市生涯课程评价 AI 驾驶舱
          </h1>
          <div className="mt-1 h-px w-full mx-auto"
            style={{ background: 'linear-gradient(to right, transparent, rgba(34,211,238,0.6), rgba(34,211,238,1), rgba(34,211,238,0.6), transparent)' }}></div>
          <div className="mt-0.5 text-center font-mono text-xs tracking-widest" style={{ color: 'rgba(34,211,238,0.4)', letterSpacing: '0.3em' }}>
            
          </div>
        </div>

        {/* 右侧：信号条 */}
        <div className="flex items-center gap-3 justify-end">
          <div className="w-px h-8 flex-shrink-0" style={{ background: 'linear-gradient(to bottom, transparent, rgba(34,211,238,0.4), transparent)' }}></div>

          {/* 迷你信号条 */}
          <div className="flex items-end gap-0.5 h-5 flex-shrink-0">
            {[3,5,7,5,8,6,4,7,5,6].map((h, i) => (
              <div key={i} className="w-1 rounded-full transition-all duration-300"
                style={{
                  height: `${h * 2}px`,
                  background: `rgba(34,211,238,${0.3 + (tick + i) % 3 * 0.2})`,
                  boxShadow: `0 0 4px rgba(34,211,238,0.4)`,
                }}></div>
            ))}
          </div>

          <div className="flex flex-col items-end flex-shrink-0">
            <span className="text-xs font-mono whitespace-nowrap" style={{ color: 'rgba(34,211,238,0.5)', letterSpacing: '0.08em' }}>SIGNAL</span>
            <span className="text-xs font-bold font-mono whitespace-nowrap" style={{ color: '#22d3ee' }}>STRONG</span>
          </div>
        </div>
      </div>
    </header>
  );
}